import React from 'react';
import Button from '../ui/Button';
import Plate from '../ui/Plate';
import { useVehicles } from '../../context/VehiclesContext';

const HeroSection = () => {
  const { vehicles } = useVehicles();
  const stockCount = vehicles.length;

  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <span className="eyebrow">Noak Hill Road · Romford, Essex</span>
          <h1>
            Real cars, <span>straight prices</span>, no showroom nonsense.
          </h1>
          <p>
            A big independent forecourt stocked with everyday cars and family
            SUVs alike — every one HPI-checked, priced fairly and ready to
            drive away today.
          </p>
          <div className="hero-buttons">
            <Button variant="primary" href="#inventory">
              Browse the Forecourt
            </Button>
            {stockCount > 0 && (
              <span className="hero-stock-plate">
                <Plate>{stockCount} IN STOCK</Plate>
                updated daily
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
